const STRATEGY = process.env.REACT_APP_MODAL_OVERRIDE_STRATEGY || 'by-priority';

const req = require.context(
  //'./',           // search under /src/custom_modules (adjust to your tree)
  '../custom_modules', // ✅ include this folder
  true,
  /customStore\.(js|ts|jsx|tsx)$/
);

/**
 * Expected per-file export: default (array) of
 * { key, import: () => import(...), store?, priority?, replace?, when?(ctx), source? }
 */

// function collect(ctx = {}) {
//   const items = [];
//   req.keys().forEach((file) => {
//     const mod = req(file);
//     const arr = mod?.default || mod?.localcustomModalsConfig || mod?.customModalsConfig;
//     if (!Array.isArray(arr)) return;

//     arr.forEach((def) => {
//       if (!def) return;
//       if (typeof def.when === 'function' && !def.when(ctx)) return;

//       const source =
//         file.includes('/custom/') ? 'custom' :
//         file.includes('/core/')   ? 'core'   : 'custom'; // treat as custom by default

//       items.push({ priority: 0, source, ...def });
//     });
//   });
//   return items;
// }
function collect(ctx = {}) {
  const items = [];
  const storeOverrideMap = {}; // <-- NEW: track overrides by key

  req.keys().forEach((file) => {
    const mod = req(file);
    const arr = mod?.default || mod?.localcustomModalsConfig || mod?.customModalsConfig;
    if (!Array.isArray(arr)) return;

    arr.forEach((def) => {
      if (!def) return;
      if (typeof def.when === 'function' && !def.when(ctx)) return;

      const key = def.key;
      const isOverride = def.override === true;

      // If override found, ALWAYS replace
      if (isOverride) {
        storeOverrideMap[key] = def;  // custom wins
      } else {
        // only add core if override not seen
        if (!storeOverrideMap[key]) {
          storeOverrideMap[key] = def;
        }
      }
    });
  });

  // Convert to array + set defaults
  return Object.values(storeOverrideMap).map((def) => ({
    priority: 0,
    source: 'custom',   // or detect from file if needed
    ...def
  }));
}


export function buildModalsConfig({ strategy = STRATEGY, ctx = {} } = {}) {
  const list = collect(ctx);

  // 🔥 1. Pre-filter using override
  // If override=true appears for a key, all other entries for that key are ignored.
  const overrideMap = new Map();

  list.forEach((item) => {
    if (!item.key) return;

    const hasOverride = overrideMap.get(item.key);

    if (item.override === true) {
      // Custom override ALWAYS wins
      overrideMap.set(item.key, item);
    } else {
      // Only add non-overridden item if no override exists
      if (!hasOverride) {
        overrideMap.set(item.key, item);
      }
    }
  });

  // Convert override-filtered map into array
  const filteredList = Array.from(overrideMap.values());

  // 🔥 2. Replacement semantics (existing logic)
  const replaced = new Set();
  filteredList.forEach((d) => d.replace && replaced.add(d.replace));

  const buckets = new Map();
  filteredList.forEach((d) => {
    if (!d?.key || typeof d.import !== "function") return;
    if (replaced.has(d.key)) return;

    const arr = buckets.get(d.key) || [];
    arr.push(d);
    buckets.set(d.key, arr);
  });

  // 🔥 3. Resolve winners (fallback to strategy only if override not used)
  const resolved = [];

  buckets.forEach((arr, key) => {
    let winner;

    if (arr.length === 1) {
      winner = arr[0];
    } else {
      // NOTE: override filtering already removed conflicts
      // This fallback only applies when multiple custom files define same key WITHOUT override

      if (strategy === "prefer-core") {
        winner = arr.find((a) => a.source === "core") || arr[0];
      } else if (strategy === "prefer-custom") {
        winner = arr.find((a) => a.source === "custom") || arr[0];
      } else {
        // default: by priority
        winner = arr.sort((a, b) => (b.priority || 0) - (a.priority || 0))[0];
      }

      if (process.env.NODE_ENV !== "production") {
        console.warn(
          `[modals] Duplicate key "${key}" (${arr.length}). Strategy=${strategy}. Winner=`,
          { source: winner?.source, priority: winner?.priority }
        );
      }
    }

    resolved.push(winner);
  });

  return resolved;
}


export const customModalsConfig = buildModalsConfig();

export function getModalByKey(key, registry = customModalsConfig) {
  const found = registry.find(m => m.key === key);
  if (!found) throw new Error(`Modal with key "${key}" not found`);
  return found;
}